__turbopack_context__.v({
  "backdrop": "AccessibilityToggle-module__T9JpBW__backdrop",
  "body": "AccessibilityToggle-module__T9JpBW__body",
  "checkbox": "AccessibilityToggle-module__T9JpBW__checkbox",
  "close": "AccessibilityToggle-module__T9JpBW__close",
  "fadeIn": "AccessibilityToggle-module__T9JpBW__fadeIn",
  "footer": "AccessibilityToggle-module__T9JpBW__footer",
  "header": "AccessibilityToggle-module__T9JpBW__header",
  "icon": "AccessibilityToggle-module__T9JpBW__icon",
  "kbd": "AccessibilityToggle-module__T9JpBW__kbd",
  "panel": "AccessibilityToggle-module__T9JpBW__panel",
  "resetButton": "AccessibilityToggle-module__T9JpBW__resetButton",
  "resetIcon": "AccessibilityToggle-module__T9JpBW__resetIcon",
  "section": "AccessibilityToggle-module__T9JpBW__section",
  "sectionIcon": "AccessibilityToggle-module__T9JpBW__sectionIcon",
  "sectionTitle": "AccessibilityToggle-module__T9JpBW__sectionTitle",
  "shortcutRow": "AccessibilityToggle-module__T9JpBW__shortcutRow",
  "slideIn": "AccessibilityToggle-module__T9JpBW__slideIn",
  "slider": "AccessibilityToggle-module__T9JpBW__slider",
  "sliderLabels": "AccessibilityToggle-module__T9JpBW__sliderLabels",
  "title": "AccessibilityToggle-module__T9JpBW__title",
  "toggle": "AccessibilityToggle-module__T9JpBW__toggle",
  "toggleRow": "AccessibilityToggle-module__T9JpBW__toggleRow",
});
